import { render, staticRenderFns } from "./index.vue?vue&type=template&id=054b8619&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054b8619')) {
      api.createRecord('054b8619', component.options)
    } else {
      api.reload('054b8619', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=054b8619&", function () {
      api.rerender('054b8619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/cities/zones/index.vue"
export default component.exports